import axios, { AxiosResponse } from "axios";
import DownloadFile from "downloadjs";
import { getRequest } from "@/Utils/Service/BackendService";

const EMAIL_LOG_ATTACHMENT_API_PREFIX = "/v2/activities/sales/email_log";

export const downloadEmailLogAttachment = async (
	emailLogId: string,
	attachmentId: string,
	fileName: string
): Promise<void> => {
	const url = `${EMAIL_LOG_ATTACHMENT_API_PREFIX}/${emailLogId}/attachments/${attachmentId}/download/`;
	const response: AxiosResponse<Blob> = await axios(
		getRequest(url, null, true, false, true)
	);
	DownloadFile(response.data, fileName);
};
